import { render, staticRenderFns } from "./InvitationResponseButtons.vue?vue&type=template&id=0a2794fc&scoped=true"
import script from "./InvitationResponseButtons.vue?vue&type=script&lang=js"
export * from "./InvitationResponseButtons.vue?vue&type=script&lang=js"
import style0 from "./InvitationResponseButtons.vue?vue&type=style&index=0&id=0a2794fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2794fc",
  null
  
)

export default component.exports